import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resolveQrZone, trackPageview } from "../lib/qrTracking";

const STORAGE_KEY = "cdp_qr_zone";

export default function useQrTracking() {
  const { pathname, search } = useLocation();

  // Capture ?qr=<zone> on every URL change and persist it
  useEffect(() => {
    const params = new URLSearchParams(search);
    const raw = params.get("qr");
    if (raw) {
      const zone = resolveQrZone(raw);
      try {
        sessionStorage.setItem(STORAGE_KEY, zone);
      } catch {
        /* ignore */
      }
      // Strip ?qr from URL to keep it clean (no reload)
      params.delete("qr");
      const clean = pathname + (params.toString() ? `?${params.toString()}` : "");
      window.history.replaceState({}, "", clean);
    }
  }, [search, pathname]);

  // Fire a pageview on each route change (after potential cleanup)
  useEffect(() => {
    let zone = null;
    try {
      zone = sessionStorage.getItem(STORAGE_KEY);
    } catch {
      zone = null;
    }
    // Skip admin paths and the long-running screen route
    if (pathname.startsWith("/admin") || pathname === "/pantalla" || pathname === "/celia") return;
    // Tracking QR desactivado temporalmente en local
    trackPageview(pathname, zone).catch(() => {});
  }, [pathname]);
}
